module.exports = __webpack_public_path__ + "img/info-screen.2641b91e.svg";